import { AxiosResponse } from 'axios'
import { api } from './api'

export default class GhostService {

	static async startSearch(vehicleId: number): Promise<AxiosResponse<void>> {
		return api.post<void>('/ghost/search/start', { vehicleId })
	}

	static async stopSearch(): Promise<AxiosResponse<void>> {
		return api.post<void>('/ghost/search/stop')
	}

	static async leave(): Promise<AxiosResponse<void>> {
		return api.post<void>('/ghost/leave')
	}
}
